import React, { useState } from "react";
import { Bar, Pie, Line } from "react-chartjs-2";
import { HiArrowsExpand } from "react-icons/hi";
import { IoCloseCircle, IoBarChart, IoPieChart } from "react-icons/io5";
import { LuLineChart } from "react-icons/lu";
// import FunnelChart from "./FunnelChart";

const GraphComponent = ({
  graphData,
  title,
  graphType,
  graphOptions,
  pieChartOptions,
  isFullScreen,
  toggleFullScreen,
  iconsToShow, //prop to control which icons to show
  onChangeGraphType, //prop to handle graph type change
  isFunnel,
  isLoading,
  hasData,
  fdate, // only to use for funnel graph
  tdate, // only to use for funnel graph
}) => {
  //console.log(fdate, tdate);
  const [hoveredIcon, setHoveredIcon] = useState(null);
  const iconStyle = (iconName) => ({
    color: hoveredIcon === iconName ? "#3436db" : "rgba(6, 21, 43,0.3)",
    cursor: "pointer",
    transition: "color 0.3s",
  });

  const renderGraph = () => {
    switch (graphType) {
      case "bar":
        return <Bar data={graphData} options={graphOptions} />;
      case "pie":
        return <Pie data={graphData} options={pieChartOptions} />;
      case "line":
        return <Line data={graphData} options={graphOptions} />;
      default:
        return <p>No graph found to display</p>;
    }
  };

  return (
    <>
      {isFullScreen ? (
        <div style={styles.fullScreenContainer}>
          <div style={styles.graphSubContainerFullScreen}>
            <div style={styles.graphHeaderFullScreen}>
              <p style={styles.graphHeaderText}>{title}</p>
              <IoCloseCircle
                size={28}
                color="rgba(6, 21, 43,0.7)"
                cursor="pointer"
                style={{ transition: "color 0.3s" }}
                onMouseEnter={(e) => (e.target.style.color = "#3436db")}
                onMouseLeave={(e) =>
                  (e.target.style.color = "rgba(6, 21, 43,0.7)")
                }
                onClick={() => {
                  toggleFullScreen();
                  setHoveredIcon(null);
                }}
              />
            </div>
            <div style={styles.graphDisplayContainerFullScreen}>
              {isLoading ? (
                <p style={{ margin: "0px", textAlign: "center" }}>
                  Please wait, loading...
                </p>
              ) : !hasData ? (
                <p style={{ margin: "0px", textAlign: "center" }}>
                  No data found
                </p>
              ) : (
                renderGraph()
              )}
            </div>
          </div>
        </div>
      ) : (
        <>
          {isFunnel ? (
            <div style={styles.graphContainer}>
              {/* <FunnelChart fdate={fdate} tdate={tdate} /> */}
            </div>
          ) : (
            <div style={styles.graphContainer}>
              <div style={styles.graphHeader}>
                <div>
                  <p style={styles.graphHeaderText}>{title}</p>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    gap: "15px",
                  }}
                >
                  {iconsToShow.includes("pie") && (
                    <IoPieChart
                      size={28}
                      style={iconStyle("pie")}
                      onMouseEnter={() => setHoveredIcon("pie")}
                      onMouseLeave={() => setHoveredIcon(null)}
                      onClick={() => onChangeGraphType("pie")}
                    />
                  )}
                  {iconsToShow.includes("bar") && (
                    <IoBarChart
                      size={28}
                      style={iconStyle("bar")}
                      onMouseEnter={() => setHoveredIcon("bar")}
                      onMouseLeave={() => setHoveredIcon(null)}
                      onClick={() => onChangeGraphType("bar")}
                    />
                  )}
                  {iconsToShow.includes("line") && (
                    <LuLineChart
                      size={28}
                      style={iconStyle("line")}
                      onMouseEnter={() => setHoveredIcon("line")}
                      onMouseLeave={() => setHoveredIcon(null)}
                      onClick={() => onChangeGraphType("line")}
                    />
                  )}
                  {iconsToShow.includes("arrow") && (
                    <HiArrowsExpand
                      size={28}
                      style={iconStyle("arrow")}
                      onMouseEnter={() => setHoveredIcon("arrow")}
                      onMouseLeave={() => setHoveredIcon(null)}
                      onClick={toggleFullScreen}
                    />
                  )}
                </div>
              </div>
              <div style={styles.graphDisplayContainer}>
                {isLoading ? (
                  <p
                    style={{
                      margin: "0px",
                      textAlign: "center",
                    }}
                  >
                    Please wait, loading...
                  </p>
                ) : !hasData ? (
                  <p style={{ margin: "0px", textAlign: "center" }}>
                    No data found
                  </p>
                ) : (
                  renderGraph()
                )}
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

const styles = {
  graphContainer: {
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    maxWidth: "700px",
    minWidth: "400px",
    width: "30%",
    maxHeight: "400px",
    minHeight: "350px",
    height: "300px",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  },
  graphHeader: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  graphHeaderText: {
    margin: "0px",
    color: "rgba(6, 21, 43,0.7)",
    fontSize: "19px",
    fontWeight: "600",
  },
  graphDisplayContainer: {
    marginTop: "15px",
    height: "300px",
    justifyContent: "center",
    display: "flex",
  },
  graphFullScreen: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80vw",
    height: "80vh",
    backgroundColor: "#ffffff",
    zIndex: 9999,
    padding: "20px",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  graphHeaderFullScreen: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "center",
    marginBottom: "20px",
  },
  fullScreenContainer: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.5)",
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  graphSubContainerFullScreen: {
    backgroundColor: "#ffffff",
    padding: "50px",
    borderRadius: "8px",
    width: "80%",
    height: "80%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  graphDisplayContainerFullScreen: {
    //marginTop: "15px",
    width: "80%",
    height: "100%",
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
  },
};

export default GraphComponent;
